import ConfirmedOffers from "./ConfirmedOffers";

export default ConfirmedOffers;
